import { useEffect } from "react";
import { GlobalStore } from "../store/global/GlobalStore";
import { fetchEnsAvatar, fetchEnsName } from "wagmi/actions";
import { useAccount } from "wagmi";
// Sets address on store, may need to watch for unnecessary runs of the hook due to deps
export const useUpdateAddressWithENS = () => {
  const { isConnected, address } = useAccount();

  useEffect(() => {
    if (isConnected && address) {
      GlobalStore.update(s => {
        s.address = address;
      });
      const fetchEns = async () => {
        const ensName = await fetchEnsName({ address, chainId: 1 });
        if (ensName) {
          const ensAvatar = await fetchEnsAvatar({ name: ensName, chainId: 1 });
          GlobalStore.update(s => {
            s.ensName = ensName;
            s.ensAvatar = ensAvatar ?? "";
          });
        }
      };
      fetchEns().catch(err => console.error(err));
    }
  }, [isConnected, address]);
};
